// Fuente única de verdad para el gating de MODOS por plan. Antes esto estaba
// disperso en `plan === 'gratis'` sueltos por InterfazV2; centralizarlo acá
// hace fácil auditar/cambiar qué modo necesita qué plan.
//
// Planes (company_profiles.plan): gratis · emprendimiento (Básico) ·
// negocio (Pro) · enterprise/enterprise1/2/3 (Ultra) · enterprise_plus (Empresa).

const PRO_OR_ULTRA = new Set([
  'negocio',
  'enterprise',
  'enterprise1',
  'enterprise2',
  'enterprise3',
  'enterprise_plus',
]);

const norm = (plan?: string | null) => (plan ?? '').toString().trim().toLowerCase();

/** Pro y Ultra (negocio + enterprise*). Empresa (enterprise_plus) incluido. */
export function isProOrUltra(plan?: string | null): boolean {
  return PRO_OR_ULTRA.has(norm(plan));
}

/** Cualquier plan pago (distinto de gratis). */
export function isPaidPlan(plan?: string | null): boolean {
  const p = norm(plan);
  return p.length > 0 && p !== 'gratis';
}

export interface ModePlanLock {
  /** Identificador de la feature bloqueada (para telemetría / debugging). */
  feature: 'catalogo' | 'asistente';
  title: string;
  message: string;
}

/**
 * Devuelve el lock a mostrar si el `plan` NO alcanza para el modo `kind`, o
 * `null` si está permitido.
 *
 * Reglas:
 *   • catalogo-ia → requiere plan pago (bloqueado en gratis; disponible desde Básico).
 *   • asistente   → requiere Pro o Ultra (bloqueado en gratis y Básico).
 *
 * IMPORTANTE: si `plan` todavía no se conoce (null/''), NO bloqueamos — así no
 * le negamos el acceso a un usuario pago mientras su plan carga. El guard de
 * generación (que pide el plan fresco a Supabase) queda como backstop.
 */
export function getModePlanLock(
  kind: string | null | undefined,
  plan: string | null | undefined,
): ModePlanLock | null {
  if (!kind || !norm(plan)) return null;

  if (kind === 'catalogo-ia' && !isPaidPlan(plan)) {
    return {
      feature: 'catalogo',
      title: 'Catálogo IA es una función paga',
      message:
        'La generación de catálogos con IA no está disponible en la prueba gratis. Mejorá tu plan para desbloquearla.',
    };
  }

  if (kind === 'asistente' && !isProOrUltra(plan)) {
    return {
      feature: 'asistente',
      title: 'El Asistente de marketing es una función Pro',
      message:
        'El asistente de marketing con IA está disponible únicamente para los planes Pro y Ultra. Mejorá tu plan para usarlo.',
    };
  }

  return null;
}
